module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"tpvByBrandTitle":"Bandeiras mais utilizadas","tpvByBrandDescription":"Total do TPV capturado por bandeira de cartão."},"en-US":{"tpvByBrandTitle":"Most used brands","tpvByBrandDescription":"Total TPV captured by each card Brand."}}')
  delete Component.options._Ctor
}
